var _defs, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 214.98 214.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff160a;}.cls-2,.cls-3{opacity:0.2;}.cls-3,.cls-4{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Doctor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5978.26,5401.89a107.49,107.49,0,1,0-107.52,107.52A107.52,107.52,0,0,0,5978.26,5401.89Z",
    transform: "translate(-5763.28 -5294.43)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M5870.74,5493.41a107.48,107.48,0,0,1-107.16-99.51q-.3,4-.3,8a107.49,107.49,0,1,0,215,0q0-4-.3-8A107.54,107.54,0,0,1,5870.74,5493.41Z",
    transform: "translate(-5763.28 -5294.43)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5870.74,5310.43A107.53,107.53,0,0,1,5978,5409.9c.2-2.65.3-5.31.3-8a107.49,107.49,0,0,0-215,0c0,2.7.1,5.36.3,8A107.48,107.48,0,0,1,5870.74,5310.43Z",
    transform: "translate(-5763.28 -5294.43)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M5947,5391a21.65,21.65,0,1,0-26.52,21.08v23.84a34.37,34.37,0,1,1-68.73,0V5416.8a44.33,44.33,0,0,0,39.32-44v-28.22h0a5,5,0,0,0-4.95-4.95h-13.38a5,5,0,1,0,0,9.91h8.42v23.27a34.39,34.39,0,0,1-34.1,34.35l-.26,0-.27,0a34.39,34.39,0,0,1-34.09-34.35v-23.27h8.42a5,5,0,1,0,0-9.91h-13.38a5,5,0,0,0-5,4.95v28.23a44.33,44.33,0,0,0,39.32,44v19.14a44.28,44.28,0,1,0,88.55,0v-23.89A21.67,21.67,0,0,0,5947,5391Zm-21.65,11.74A11.74,11.74,0,1,1,5937.1,5391,11.76,11.76,0,0,1,5925.36,5402.76Z",
    transform: "translate(-5763.28 -5294.43)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctor);
export default __webpack_public_path__ + "static/media/Doctor.f535ffbb94118941bdb35d93c62f1883.svg";
export { ForwardRef as ReactComponent };